import { useNavigate } from "react-router-dom";
import club_logo from '../images/platform_logo.png'
import { useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { GridLoader } from "react-spinners";
import { useCookies } from "react-cookie";

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [cookies, setCookie, removeCookie] = useCookies();
  const [userProfile, setUserProfile] = useState({});
  const [errMsg, setErrMsg] = useState(null);

  const handleLogin = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("login_id", formFields.login_id);
    formData.append("password", formFields.password);

    const date = new Date();
    let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 24 hours

    try {
        const response = await axios.post(base_url + '/login.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        console.log(response);
        if (response.data.status) {
            setLoading(false);
            setCookie("userProfile", response.data.user, {
                path: "/",
                maxAge: expiresDate,
                secure: true,
            });
            setUserProfile(response.data.user);
            navigate("/dashboard/home");
        } else {
            setLoading(false);
            setErrMsg(response.data.response);
        }
    } catch (error) {
        setLoading(false);
        setErrMsg('Network error');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-96 space-y-3">
        <div className='flex flex-col justify-start items-center w-full mt-[10px] mb-[20px]'>
            <img src={club_logo} className="h-[100px] rounded-full mr-2" alt="logo" />
            <h2 className="text-center text-lg font-semibold">Admin Login</h2>
        </div>
        {errMsg != null && <div className="border border-1 border-[#ff0000] mb-[10px] bg-[#ffdede] py-2 rounded-[5px] flex items-center justify-center">
            <p className="text-[#d40000]">{errMsg}</p>
        </div>}
        <input onChange={(e) => setFormFields({...formFields, login_id: e.target.value})} className="w-full border p-2 rounded" placeholder="Login ID" />
        <input onChange={(e) => setFormFields({...formFields, password: e.target.value})} className="w-full border p-2 rounded" placeholder="Password" />
        <button 
          className="bg-blue-600 h-[40px] flex items-center justify-center text-white w-full rounded hover:bg-blue-700"
          onClick={handleLogin}
        >
          {loading ? (
                <GridLoader
                    color={'#ffffff'}
                    loading={loading}
                    size={5}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                ) : 'Log in'
            }
        </button>
      </div>
    </div>
  );
}
